import React, { useEffect, useState, useRef } from "react";

const CarruselImagenes = () => {
  const imagenes = [
    "https://www.impresoras3d.com/wp-content/uploads/2022/06/Portada-ideas-Pokemon-1400x735.jpg",
    "https://www.impresoras3d.com/wp-content/uploads/2022/06/POKEMON-LOWPOLY.jpg",
    "https://www.3ds.com/assets/invest/2021-12/complex-parts.jpeg",
  ];

  const [indiceActual, setIndiceActual] = useState(0);
  const [fade, setFade] = useState(true);
  const [pausado, setPausado] = useState(false);
  const [hovered, setHovered] = useState(false);
  const intervaloRef = useRef(null);

  useEffect(() => {
    if (!pausado) {
      intervaloRef.current = setInterval(() => {
        siguienteImagen();
      }, 5000);
    }
    return () => clearInterval(intervaloRef.current);
  }, [indiceActual, pausado]);

  const siguienteImagen = () => {
    setFade(false);
    setTimeout(() => {
      setIndiceActual((prev) => (prev + 1) % imagenes.length);
      setFade(true);
    }, 300);
  };

  const anteriorImagen = () => {
    setFade(false);
    setTimeout(() => {
      setIndiceActual((prev) =>
        prev === 0 ? imagenes.length - 1 : prev - 1
      );
      setFade(true);
    }, 300);
  };

  const irAImagen = (index) => {
    setFade(false);
    setTimeout(() => {
      setIndiceActual(index);
      setFade(true);
    }, 300);
  };

  const alternarPausa = () => {
    setPausado((prev) => !prev);
  };

  return (
    <div
      style={{
        position: "relative",
        width: "95%",
        maxWidth: "1000px",
        margin: "auto",
        marginTop: "15px",
        overflow: "hidden",
        borderRadius: "16px",
        boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
        backgroundColor: "#000",
        animation: "zoomIn 0.6s ease-in-out",
      }}
    >
      <img
        src={imagenes[indiceActual]}
        alt={`slide-${indiceActual}`}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          width: "100%",
          height: "350px",
          objectFit: "cover",
          display: "block",
          opacity: fade ? 1 : 0,
          transform: hovered
            ? "scale(1.03)"
            : fade
            ? "scale(1)"
            : "scale(1.02)",
          transition: "opacity 0.5s ease, transform 0.5s ease",
        }}
      />

      {/* Botón anterior */}
      <button onClick={anteriorImagen} style={estiloBoton("left")}>
        ◀
      </button>

      {/* Botón siguiente */}
      <button onClick={siguienteImagen} style={estiloBoton("right")}>
        ▶
      </button>

      {/* Puntos indicadores + botón pausa */}
      <div
        style={{
          position: "absolute",
          bottom: "15px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {imagenes.map((_, index) => (
          <span
            key={index}
            onClick={() => irAImagen(index)}
            style={{
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              backgroundColor:
                index === indiceActual ? "#fff" : "rgba(255,255,255,0.4)",
              cursor: "pointer",
              border: "1px solid #999",
              transition: "background-color 0.3s, transform 0.2s",
              transform: index === indiceActual ? "scale(1.2)" : "scale(1)",
            }}
          />
        ))}

        {/* Botón Pausa/Reanudar */}
        <button
          onClick={alternarPausa}
          style={{
            background: "rgba(0,0,0,0.5)",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            padding: "6px 10px",
            cursor: "pointer",
            fontSize: "14px",
            marginLeft: "10px",
            backdropFilter: "blur(4px)",
          }}
          title={pausado ? "Reanudar carrusel" : "Pausar carrusel"}
        >
          {pausado ? "▶" : "⏸"}
        </button>
      </div>

      {/* Keyframes de entrada */}
      <style>
        {`
          @keyframes zoomIn {
            from {
              opacity: 0;
              transform: scale(0.95);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }
        `}
      </style>
    </div>
  );
};

// Estilo de botones reutilizable
const estiloBoton = (posicion) => ({
  position: "absolute",
  top: "50%",
  [posicion]: "10px",
  transform: "translateY(-50%)",
  fontSize: "26px",
  background: "rgba(0,0,0,0.5)",
  color: "#fff",
  border: "none",
  borderRadius: "50%",
  padding: "10px 14px",
  cursor: "pointer",
  transition: "background 0.3s, transform 0.2s",
  zIndex: 1,
  backdropFilter: "blur(4px)",
});

export default CarruselImagenes;

